import React, { useContext, useEffect, useRef } from "react";
import "./ChainCharmSelector.css";
import stateContext from "../../Context/StateContext";

const ChainCharmSelector = () => {
    const globalState = useContext(stateContext);
    const {
        activeCharm,
        chainCharmSide,
        setActiveCharm,
        setChainCharmSide,
        chainCharmData,
    } = globalState;
    const charmList = chainCharmData || [];
    const selectedCharmType = activeCharm?.charm || null;
    const selectedSize = activeCharm?.size || null;

    const currentCharm = charmList.find(
        (c) => c.charmType === selectedCharmType
    );
    const sizes = currentCharm ? Object.keys(currentCharm.sizeOptions) : [];

    const prevSideRef = useRef(chainCharmSide);
    const sideLabels = {
        None: {
            en: "None",
            ar: "بدون",
        },
        Both: {
            en: "Both",
            ar: "على الجهتين",
        },
        Right: {
            en: "Right",
            ar: "اليمين",
        },
        Left: {
            en: "Left",
            ar: "اليسار",
        },
    };

    useEffect(() => {
        if (!activeCharm || !activeCharm.size || !activeCharm.charm) return;

        const charm = charmList.find((c) => c.charmType === activeCharm.charm);
        if (!charm) return;

        const price = charm.sizeOptions[activeCharm.size]?.price || 0;

        if (chainCharmSide === "None") {
            globalState.setChainCharmPrice(0);
        } else if (chainCharmSide === "Both") {
            globalState.setChainCharmPrice(price * 2);
        } else {
            globalState.setChainCharmPrice(price);
        }
    }, [activeCharm, chainCharmSide, charmList]);

    const handleCharmTypeChange = (charmType) => {
        const charm = charmList.find((c) => c.charmType === charmType);
        if (!charm) return;

        const { size: defaultSize } = getFirstSizeOption(charm);
        setActiveCharm({ charm: charmType, size: defaultSize });
    };
    useEffect(() => {
        if (charmList.length > 0 && !activeCharm?.charm) {
            const firstCharm = charmList[0];
            const { size: defaultSize } = getFirstSizeOption(firstCharm);
            setActiveCharm({ charm: firstCharm.charmType, size: defaultSize });
        }
    }, [charmList]);
    const handleSizeChange = (size) => {
        if (!selectedCharmType) return;
        setActiveCharm({ charm: selectedCharmType, size });

        if (chainCharmSide !== "Both" && chainCharmSide !== "None") {
            globalState.setChainCharmPrice(
                currentCharm.sizeOptions[size].price
            );
        }

        if (chainCharmSide === "Both") {
            globalState.setChainCharmPrice(
                currentCharm.sizeOptions[size].price * 2
            );
        }

        if (chainCharmSide === "None") {
            globalState.setChainCharmPrice(0);
        }
    };

    return (
        <div className="charm-container">
            <h4 className="charm-title">
                {globalState.selectedFontLanguage === "Arabic"
                    ? "احجار على السلسال"
                    : "Select charms on chain"}
            </h4>

            <div className="charm-side-row">
                <label className="charm-side-label">Charms:</label>
                <div className="charm-side-options">
                    {["Left", "Right", "Both", "None"].map((side) => (
                        <div
                            key={side}
                            className={`charm-side-card ${
                                chainCharmSide === side ? "active" : ""
                            }`}
                            onClick={() => setChainCharmSide(side)}
                        >
                            {globalState.selectedFontLanguage === "Arabic"
                                ? sideLabels[side].ar
                                : sideLabels[side].en}
                        </div>
                    ))}
                </div>
            </div>

            <div className="charm-options-row">
                <label className="type-label">Type:</label>
                <div className="charm-options">
                    {charmList.map((charm) => (
                        <div
                            key={charm.charmType}
                            className={`charm-item ${
                                selectedCharmType === charm.charmType
                                    ? "active"
                                    : ""
                            }`}
                            onClick={() =>
                                handleCharmTypeChange(charm.charmType)
                            }
                        >
                            {/* Optional: replace with actual icon if available */}
                            <div className="charm-icon-placeholder" />
                            <span className="charm-label">
                                {globalState.selectedFontLanguage === "Arabic"
                                    ? charm.labels?.ar || charm.charmType
                                    : charm.labels?.en || charm.charmType}
                            </span>
                        </div>
                    ))}
                </div>
            </div>

            {currentCharm && sizes.length > 0 && (
                <div className="size-options-row">
                    <label className="charm-side-label">Size:</label>
                    <div className="size-options">
                        {sizes.map((size) => {
                            const option = currentCharm?.sizeOptions[size];
                            return (
                                <button
                                    key={size}
                                    className={`size-button ${
                                        selectedSize === size ? "selected" : ""
                                    }`}
                                    onClick={() => handleSizeChange(size)}
                                    disabled={!currentCharm}
                                >
                                    <div className="size-text">
                                        {size.replace(/\s+/g, "")}
                                    </div>

                                    {/* Show carat only if it exists */}
                                    {option?.carat && (
                                        <div className="size-carat">
                                            ({option.carat}ct)
                                        </div>
                                    )}

                                    <div className="size-price">
                                        {option?.price} SAR
                                    </div>
                                </button>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ChainCharmSelector;

// Helper function
export function getFirstSizeOption(charm) {
    const firstSizeKey = Object.keys(charm.sizeOptions)[0];
    const sizeDetails = charm.sizeOptions[firstSizeKey];

    return {
        size: firstSizeKey,
        price: sizeDetails.price,
    };
}
